import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD_g-Yj09s3sVv3kmdzXOTP2ibbUVjFeGA",
  authDomain: "gcb-web-bb21b.firebaseapp.com",
  projectId: "gcb-web-bb21b",
  storageBucket: "gcb-web-bb21b.firebasestorage.app",
  messagingSenderId: "450370847149",
  appId: "1:450370847149:web:aa9c057bfb1d1be866a124"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
